.followerCount {
  font-size: 15px;
  line-height: 1.8;
  color: rgb(0 0 0 / 60%);
}

.value {
  font-weight: 600;
}

.unit {
  font-weight: 300;
}
